export const i18nContentHash = 'b2bc420'
